export {default} from './DesktopDeliveryMenu.container';
